export const addStar = (room, user) => {
  let arrayMetaData = [];
  const tempUserMetaData = user.metaData;

  if (typeof user.metaData.starred !== 'undefined') {
    arrayMetaData = user.metaData.starred.split(',');
  }

  const roomInfo = JSON.parse(room.data);
  if (!arrayMetaData.includes(roomInfo.chatroom_id.toString())) {
    arrayMetaData.push(roomInfo.chatroom_id);
  } else {
    arrayMetaData = arrayMetaData.filter(e => e !== roomInfo.chatroom_id.toString());
  }

  tempUserMetaData.starred = arrayMetaData.toString();

  user.updateMetaData(tempUserMetaData, () => {
    return arrayMetaData.toString();
  });
};

export const addArchive = (room, user) => {
  let arrayMetaData = [];
  const tempUserMetaData = user.metaData;

  if (typeof user.metaData.archived !== 'undefined') {
    arrayMetaData = user.metaData.archived.split(',');
  }

  const roomInfo = JSON.parse(room.data);
  if (!arrayMetaData.includes(roomInfo.chatroom_id.toString())) {
    arrayMetaData.push(roomInfo.chatroom_id);
  } else {
    arrayMetaData = arrayMetaData.filter(e => e !== roomInfo.chatroom_id.toString());
  }

  tempUserMetaData.archived = arrayMetaData.toString();

  user.updateMetaData(tempUserMetaData, () => {
    return arrayMetaData.toString();
  });
};
